import { Pipe, PipeTransform } from '@angular/core';
import memoize from '@github/memoize/decorator';
import { environment } from '@macs-frontend/env';

@Pipe({
  name: 'uploads',
})
export class UploadsPipe implements PipeTransform {
  uploadsPath = environment.images_path;

  @memoize()
  transform(value: any): any {
    return value ? this.uploadsPath + value : '';
  }
}
